import { render, staticRenderFns } from "./SummaryPage.vue?vue&type=template&id=68bf220b&scoped=true&"
import script from "./SummaryPage.vue?vue&type=script&lang=ts&"
export * from "./SummaryPage.vue?vue&type=script&lang=ts&"
import style0 from "./SummaryPage.vue?vue&type=style&index=0&id=68bf220b&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "68bf220b",
  null
  
)

export default component.exports